import React, { useRef, useState } from "react";
import { images } from "../../constants";
import Input from "../UI/input/Input";
import Button from "../UI/button/Button";
import classes from "./ResetPassword.module.scss";
import { useLocation, useNavigate } from "react-router-dom";
import toast from "react-hot-toast";
import { useResetPasswordMutation } from "../../api/authApi";

interface ResetPasswordData {
    password: string;
    confirmPassword: string;
}

function ResetPasswordBox() {
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const token = queryParams.get("token");
    localStorage.setItem("token", token ?? "");

    const passwordRef = useRef<HTMLInputElement>(null);
    const confirmPasswordRef = useRef<HTMLInputElement>(null);
    const navigate = useNavigate();
    const [ResetPassword, { isLoading }] = useResetPasswordMutation();

    const [passwordValue, setPasswordValue] = useState("");

    // ✅ Password validation function
    const validatePassword = (password?: string) => {
        if (!password) return false;
        const lengthOk = password.length >= 8;
        const upperOk = /[A-Z]/.test(password);
        const numberOk = /[0-9]/.test(password);
        const specialOk = /[!@#$%^&*(),.?":{}|<>]/.test(password);
        return lengthOk && upperOk && numberOk && specialOk;
    };

    const ResetPasswordHandler = async (e: React.FormEvent) => {
        e.preventDefault();
        const password = passwordRef.current?.value || "";
        const confirmPassword = confirmPasswordRef.current?.value || "";

        if (!password || !confirmPassword) {
            toast.error("Please enter both Password and Confirm Password");
            return;
        }

        if (!validatePassword(password)) {
            toast.error("Password does not meet the required rules");
            return;
        }

        if (password !== confirmPassword) {
            toast.error("Passwords do not match");
            return;
        }

        const credentials: ResetPasswordData = { password, confirmPassword };

        try {
            const data = await ResetPassword(credentials).unwrap();
            toast.success(data?.message || "Password reset successful!");
            navigate("/login");
        } catch (err: any) {
            const errorMessage =
                err?.data?.message || err?.error || "Something went wrong";
            toast.error(errorMessage);
        }
    };

    return (
        <div className={classes.container}>
            <div className={classes.ResetPasswordBox}>
                <div className={classes.logo}>
                    <img src={images.logo} alt="digikala" />
                </div>
                <h2 className={classes.title}>Reset Password</h2>
                <form onSubmit={ResetPasswordHandler}>
                    <Input
                        ref={passwordRef}
                        type="password"
                        id="New Password"
                        placeholder="Enter New Password"
                        onChange={(e) => setPasswordValue(e.target.value)}
                    />

                    <Input
                        ref={confirmPasswordRef}
                        type="password"
                        id="Confirm Password"
                        placeholder="Confirm Password"
                    />

                    {passwordValue && (
                        <div style={{ marginBottom: "20px", fontSize: "12px", fontFamily: "Poppins" }}>
                            <div style={{ color: passwordValue.length >= 8 ? "green" : "red" }}>
                                • At least 8 characters
                            </div>
                            <div style={{ color: /[A-Z]/.test(passwordValue) ? "green" : "red" }}>
                                • At least one uppercase letter
                            </div>
                            <div style={{ color: /[0-9]/.test(passwordValue) ? "green" : "red" }}>
                                • At least one number
                            </div>
                            <div
                                style={{
                                    color: /[!@#$%^&*(),.?":{}|<>]/.test(passwordValue)
                                        ? "green"
                                        : "red",
                                }}
                            >
                                • At least one special character
                            </div>
                        </div>
                    )}

                    <Button type="submit" disabled={isLoading}>
                        {isLoading ? "Submitting..." : "Submit"}
                    </Button>
                </form>
            </div>
        </div>
    );
}

export default ResetPasswordBox;
